// Mock data for Unnie Korean Skincare Revolution

export const salonInfo = {
  name: "Unnie",
  subtitle: "Korean Skincare Revolution",
  tagline: "Authentische koreanische Hautpflege",
  headline: "Erster koreanischer Hautpflege-Salon in Niedersachsen",
  description: "Entdecken Sie die Geheimnisse der koreanischen Hautpflege. Spezialisiert auf richtige Hautvorbereitung, Anti-Aging und durchblutungsfördernde Massagen. Unsere Behandlungen unterscheiden sich grundlegend von gewöhnlichen Treatments.",
  certification: "Zertifiziert in Südkorea (Korea Mikwang)",
  phone: "+49 157 347 16 495",
  whatsapp: "+49 157 347 16 495",
  email: "info@unnie-aesthetics.de",
  address: "Osnabrücker Str. 61, 49214 Bad Rothenfelde",
  city: "Bad Rothenfelde",
  hours: {
    weekdays: "11:00 - 20:30 Uhr",
    wednesday: "11:00 - 20:30 Uhr",
    saturday: "11:00 - 18:00 Uhr",
    sunday: "Geschlossen"
  },
  promotion: {
    active: true,
    title: "NEUERÖFFNUNG – EINFÜHRUNGSPREISE",
    endDate: "31.05.2026"
  },
  instagram: "https://instagram.com/unnie_koreanskincare"
};


export const services = [
  {
    id: 1,
    name: "Korean Glass Skin Facial",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/l5lxjqat_1000183677.png",
    description: "Ein vollständiges Reinigungs- und Pflegeritual für strahlend gesunde Haut.\n\nGesichtsreinigung und Tiefenreinigung, intensive Gesichts-, Hals- und Dekolleté-Massage, individuell ausgewählte Masken, LED-Therapie und Glow-Pflege.\n\nFür ein frisches, strahlendes und gepflegtes Hautbild mit dem typischen Glass-Skin-Glow.",
    duration: "ca. 90 Minuten",
    price: "89 €",
    category: "facial"
  },
  {
    id: 2,
    name: "Aqua Facial + Cooling",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/nf4l8r82_1000183690.png",
    description: "Aqua Peel, Gesichts-, Hals- und Dekolleté-Massage, Maske und LED-Therapie für ein frisches, geklärtes und gepflegtes Hautbild.",
    duration: "ca. 70 Minuten",
    price: "119 €",
    category: "facial"
  },
  {
    id: 3,
    name: "Calming Care (Beruhigung & Hautvorbereitung)",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/e6wbyn83_1000183680.png",
    description: "Unsere Empfehlung als intensive erste koreanische Hautpflegebehandlung.\n\nEin intensives und zugleich sanftes Ritual, das die Haut gründlich reinigt, beruhigt und optimal auf weiterführende Behandlungen vorbereitet.\n\nGesichtsreinigung, Ultraschallreinigung, Radiofrequenz (RF) zur Unterstützung der Hautstraffung und für einen natürlichen Lifting-Effekt, intensive Gesichts-, Hals- und Dekolleté-Massage, zwei individuell ausgewählte Masken, LED-Therapie und Cold-Hammer-Kryotherapie.\n\nBeruhigung, Regeneration, Straffung und optimale Vorbereitung der Haut auf weiterführende Behandlungen.",
    duration: "ca. 90 Minuten",
    price: "119 €",
    category: "facial"
  },
  {
    id: 4,
    name: "Oxygen Collagen Therapy",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/alxh63ax_1000183679.png",
    description: "Intensive Sauerstofftherapie mit tiefer Feuchtigkeitspflege.\n\nSauerstofftherapie versorgt die Haut intensiv mit Feuchtigkeit, unterstützt ihre Regeneration und hilft müde wirkender Haut, wieder frisch und revitalisiert auszusehen. Für mehr Ausstrahlung, einen gesunden Glow und ein frisches, gepflegtes Hautbild.\n\nInklusive Gesichts-, Hals- und Dekolleté-Massage, zwei Masken, LED-Therapie und Cold-Hammer-Kryotherapie.\n\nBesonders empfohlen für trockene, müde und reife Haut.",
    duration: "ca. 90 Minuten",
    price: "109 €",
    category: "facial"
  },
  {
    id: 5,
    name: "Return Care (Lymphdrainage)",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/zllntxxv_1000183678.png",
    description: "Tiefenreinigung, Ultraschall zur Unterstützung der Lymphdrainage, Gesichts-, Hals- und Dekolleté-Massage, Maske und Cold-Hammer-Kryotherapie.\n\nUnterstützt den natürlichen Lymphfluss, hilft Schwellungen zu reduzieren und fördert die Regeneration der Haut.",
    duration: "ca. 75 Minuten",
    price: "99 €",
    category: "facial"
  },
  {
    id: 11,
    name: "Unnie's Lifting Session – Signature Treatment",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/e6wbyn83_1000183680.png",
    description: "Radiofrequenz (RF), intensive Lifting-Massage für Gesicht, Hals und Dekolleté, LED-Therapie, Cold-Hammer-Kryotherapie und koreanische Premium-Wirkstoffe.\n\nFür einen natürlichen Lifting- und Anti-Aging-Effekt, definiertere Gesichtskonturen und ein strahlendes Hautbild.",
    duration: "ca. 75 Minuten",
    price: "99 €",
    featured: true,
    category: "signature"
  },
  {
    id: 13,
    name: "Korean Beauty Premium Ritual",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/l5lxjqat_1000183677.png",
    description: "Eines der luxuriösesten koreanischen Beauty-Erlebnisse bei Unnie.\n\nGründliche Gesichtsreinigung und Tiefenreinigung, individuell ausgewähltes Peeling, Radiofrequenz (RF) zur Unterstützung der Hautstraffung sowie eine besonders intensive, individuell angepasste Lifting-Massage für Gesicht, Hals und Dekolleté — das Herz dieses Rituals.\n\nDie intensive Lifting-Massage entspannt die Gesichtsmuskulatur, regt die Durchblutung an, unterstützt den natürlichen Lymphfluss und schenkt einen natürlichen Lifting-Effekt sowie ein frisches, strahlendes Erscheinungsbild.\n\nErgänzt durch Sauerstofftherapie für intensive Feuchtigkeitspflege und Unterstützung der Regeneration, zwei individuell ausgewählte Masken, LED-Therapie und — wo passend — Cold-Hammer-Kryotherapie. Mit hochwertigen koreanischen Premium-Wirkstoffen.",
    duration: "ca. 90 Minuten",
    price: "125 €",
    featured: true,
    gift: true,
    excludedFromDiscounts: true,
    category: "signature"
  },
  {
    id: 6,
    name: "Microneedling",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/1gqs62r7_1000183681.png",
    description: "Professionelles Microneedling mit koreanischen Premium-Wirkstoffen.\n\nZur Verbesserung von Aknenarben, Pigmentflecken, feinen Linien und zur Unterstützung der Hauterneuerung.\n\nInklusive Gesichts-, Hals- und Dekolleté-Massage und LED-Therapie.",
    duration: "ca. 60 Minuten",
    price: "139 €",
    packages: [
      { label: "Kur: 2 Behandlungen", price: "240 €" },
      { label: "3 Behandlungen", price: "320 €" },
    ],
    category: "special"
  },
  {
    id: 7,
    name: "Akne Behandlung (Intensiv)",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/ey8wiv78_1000183684.png",
    description: "Reinigung, Tiefenreinigung, Ausreinigung — Gesichts-, Hals- und Dekolleté-Behandlung.",
    duration: "60 Min.",
    price: "79 €",
    category: "acne"
  },
  {
    id: 9,
    name: "Akne Behandlung (Schüler)",
    iconUrl: "https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/jeoi056u_1000183686.png",
    description: "Spezielle Behandlung für Schüler — Reinigung und Ausreinigung.",
    duration: "45 Min.",
    price: "49 €",
    category: "acne"
  }
];


// Single gallery — visually grouped (training, treatment/mask, light therapy, studio/sign)
export const galleryImages = [
  // === White coat / Korea Mikwang training (grouped together) ===
  {
    id: 'tr1',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/l0ab2baq_1000187652.jpg',
    alt: 'Korea Mikwang — Behandlung mit Kräutermaske',
  },
  {
    id: 'tr2',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/p0mxu2mn_1000187650.jpg',
    alt: 'Korea Mikwang — professionelles Equipment',
  },
  {
    id: 'tr3',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/iruoj7ew_1000187653.jpg',
    alt: 'Korea Mikwang — Aqua Plus Behandlung',
  },
  {
    id: 'tr4',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/dkdq6x1r_1000160211.jpg',
    alt: 'Behandlung im weißen Arbeitskittel',
  },
  {
    id: 'tr5',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/8ga8dkre_1000160246.jpg',
    alt: 'Diplom Korea Mikwang Beauty Academy',
  },

  // === Massage / Treatment / Mask (warm, grouped together) ===
  {
    id: 'ms1',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/avc6a8y8_1000187656.jpg',
    alt: 'Koreanische Gesichtsmassage',
  },
  {
    id: 'ms2',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/vvdhpy38_1000187648.jpg',
    alt: 'Pflegende Gesichtsmaske',
  },
  {
    id: 'ms2b',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/nbky75s7_1000156520.jpg',
    alt: 'Elegante blaue Gesichtsmaske',
  },
  {
    id: 'ms3',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/1wodq8um_1000176688.jpg',
    alt: 'Blaue Pflegemaske',
  },
  {
    id: 'ms4',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/l1ymooe3_1000172387.jpg',
    alt: 'Koreanisches Pflegeritual',
  },
  {
    id: 'ms5',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/kwqyv0k4_1000187651.jpg',
    alt: 'Entspannung in der Behandlungskabine',
  },

  // === LED light therapy (grouped together) ===
  {
    id: 'lg1',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/ed0swnu4_1000187649.jpg',
    alt: 'LED Lichttherapie',
  },
  {
    id: 'lg2',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/8cecj2wu_1000187655.jpg',
    alt: 'Blaues LED Licht',
  },

  // === Studio / Sign / Location ===
  {
    id: 'st1',
    url: 'https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/toife0nx_1000187657.jpg',
    alt: 'Unnie Korean Aesthetics — Bad Rothenfelde',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Carmen W.',
    text:
      'Ich habe mich rundum wohlgefühlt – die Gesichtsbehandlung war einfach großartig! Absolut empfehlenswert. Ich komme auf jeden Fall wieder!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Susann H.',
    text:
      'Meine Haut war nach 1,5 Stunden erfrischt und klar. Danke für die wunderbare Behandlung – ich komme wieder!',
    rating: 5,
  },
  {
    id: 3,
    name: 'Laura P.',
    text:
      'Tolles Studio mit entspannender Atmosphäre. Ich empfehle die Glass-Skin-Gesichtsbehandlung.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Sylwia S.',
    text:
      'Ich war schon zweimal dort und bin sehr zufrieden. Meine Haut war danach strahlend, frisch und sichtbar verbessert.',
    rating: 5,
  },
  {
    id: 5,
    name: 'Aga R.',
    text: 'Ein Gefühl wie im Spa – pure Entspannung.',
    rating: 5,
  },
  {
    id: 6,
    name: 'Paula U.',
    text:
      'Über Instagram gefunden – endlich authentische koreanische Hautpflege in meiner Nähe. Sehr zufrieden!',
    rating: 5,
  },
];

// Mock booking submission
export const submitBooking = (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Buchung gespeichert:", bookingData);
      resolve({
        success: true,
        message: "Vielen Dank für Ihre Buchung! Wir werden uns in Kürze bei Ihnen melden.",
        bookingId: Math.random().toString(36).substr(2, 9)
      });
    }, 1000);
  });
};
